import React, { useEffect, useState } from 'react';
import { Table, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import axiosInstance from '../../../utils/axiosConfig';
import { useAuth } from '../../../contexts/AuthContext';

const MaintenanceCalculatorTable = () => {
    const navigate = useNavigate();
    const { hasRole } = useAuth();
    const [maintenanceData, setMaintenanceData] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchMaintenanceData = async () => {
        try {
            setLoading(true);
            const response = await axiosInstance.get('/maintenance-calculator');
            const data = response.data.data || response.data || [];
            setMaintenanceData(Array.isArray(data) ? data : []);
        } catch (error) {
            console.error('Error fetching maintenance data:', error);
            toast.error('Failed to load maintenance data');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchMaintenanceData();
    }, []);

    const handleEdit = (item) => {
        navigate(`/cms/maintenance-calculator/edit/${item.id}`, { state: { maintenanceData: item } });
    };

    const handleDelete = async (id) => {
        if (!window.confirm('Are you sure you want to delete this maintenance record?')) return;
        try {
            await axiosInstance.delete(`/maintenance-calculator/${id}`);
            toast.success('Maintenance record deleted successfully!');
            fetchMaintenanceData();
        } catch (error) {
            console.error('Error deleting maintenance record:', error);
            toast.error(error.response?.data?.message || 'Failed to delete maintenance record');
        }
    };

    const kmFields = [
        { key: 'km_10000', label: '10,000 km' },
        { key: 'km_20000', label: '20,000 km' },
        { key: 'km_30000', label: '30,000 km' },
        { key: 'km_40000', label: '40,000 km' },
        { key: 'km_50000', label: '50,000 km' },
        { key: 'km_60000', label: '60,000 km' },
        { key: 'km_70000', label: '70,000 km' },
        { key: 'km_80000', label: '80,000 km' },
        { key: 'km_90000', label: '90,000 km' },
        { key: 'km_100000', label: '100,000 km' }
    ];

    if (loading) {
        return <div className="text-center">Loading...</div>;
    }

    return (
        <Table responsive striped bordered hover className='text-center'>
            <thead>
                <tr>
                    <th>Sr. No.</th>
                    <th>Vehicle</th>
                    <th>Engine Oil</th>
                    <th>Oil & Filter</th>
                    <th>Mileage</th>
                    <th>Price (SAR)</th>
                    <th>Actions</th>
                </tr>
            </thead>
            <tbody>
                {maintenanceData.length === 0 ? (
                    <tr>
                        <td colSpan="7" className="text-center">No maintenance records found</td>
                    </tr>
                ) : (
                    maintenanceData.map((item, index) => {
                        const rowSpanCount = kmFields.length;
                        return kmFields.map((km, kmIndex) => (
                            <tr key={`${item.id}-${km.key}`}>
                                {kmIndex === 0 && (
                                    <>
                                        <td rowSpan={rowSpanCount}>{index + 1}</td>
                                        <td rowSpan={rowSpanCount}>{item.vehicle_id}</td>
                                        <td rowSpan={rowSpanCount}>{item.engine_oil}</td>
                                        <td rowSpan={rowSpanCount}>{item.oil_and_filter}</td>
                                    </>
                                )}
                                <td>{km.label}</td>
                                <td>{item[km.key] || '-'}</td>
                                {kmIndex === 0 && (
                                    <td rowSpan={rowSpanCount}>
                                        <div className="d-flex flex-column gap-1">
                                            <Button variant="warning" size="sm" onClick={() => handleEdit(item)}>
                                                Edit
                                            </Button>
                                            {hasRole('it') && (
                                                <Button variant="danger" size="sm" onClick={() => handleDelete(item.id)}>
                                                    Delete
                                                </Button>
                                            )}
                                        </div>
                                    </td>
                                )}
                            </tr>
                        ));
                    })
                )}
            </tbody>
        </Table>
    );
};

export default MaintenanceCalculatorTable;
